import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-subscription-terms',
  templateUrl: './subscription-terms.component.html',
  styleUrls: ['./subscription-terms.component.scss'],
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionTermsComponent {
  constructor(private location: Location) {}

  back() {
    this.location.back();
  }
}
